module.exports = __webpack_public_path__ + "img/chiquita-vector-logo.89b5c7b8.svg";